module.exports = __webpack_public_path__ + "static/media/BAP4.90b8131e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/tutorials/BAP4.png
 ** module id = 682
 ** module chunks = 0
 **/